import Vue from 'vue'
import moment from 'moment'
import Event from './support/event'
import axios from 'axios'
import SweetAlert from './support/SweetAlert.js'
import Form from 'form-backend-validation'
import lodash from 'lodash'
import 'sweetalert'
import Vuex from 'vuex'
import DebugLog from "./support/DebugLog";

/*************************
 *  DEBUG MODE
 *************************/
window.debug_mode = false;
/*************************
 * 
*************************/

window.Vue = Vue;
import 'vue-resource'

// jQuery and Bootstrap JS
window.$ = window.jQuery = require('jquery');
require('bootstrap');

/*
 * Axios setup
 */
window.axios = axios;

axios.interceptors.response.use(function (response) {
    // Successful response so we know the connection is OK
    window.store.commit('setApiStatus', true);
    window.store.commit('setWebStatus', true);

    return response;
}, function (error) {
    // If the request status is 0, no response was returned so we'll assume there's no connection
    if (error.request.status === 0) {
        window.store.commit('setApiStatus', false);
        window.store.commit('setWebStatus', false);
    }

    return Promise.reject(error);
});

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.Vuex = Vuex;
window._ = lodash;
window.moment = moment;
window.Event = Event;
window.HelpdeskAlert = SweetAlert;
window.Form = Form;
window.debug = DebugLog;
